import * as moment from 'moment';

/**
 * DATE FORMATS BLOCKS
 */
export const DATE_BLOCK_BASIC = "DD/MM HH:mm";
export const DATE_BLOCK_FRANCE = "DD/MM HH:mm:ss";
/**
 * DATE FORMATS
 */
export const DATE_DEFAULT_FORMAT = 'YYYY-MM-DD';
export const DATE_D_M_Y_SLASH_FORMAT = 'DD/MM/YYYY';
export const DATE_MOUNTH_DAY_FORMAT = 'MM_DD'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIMEZONE_FORMAT = 'YYYY-MM-DD HH:mm Z';
export const DATE_TIMEZONE_FORMAT_Z = 'YYYY-MM-DDTHH:mm:ssZ';
export const DATE_TIME_AT_7_0_0 = 'YYYY-MM-DD 07:00:00';
export const DATE_TIME_AT_8_0_0 = 'YYYY-MM-DD 08:00:00';
export const DATE_TIME_AT_18_0_0 = 'YYYY-MM-DD 18:00:00';
export const DATE_TIME_AT_0_0_0 = 'YYYY-MM-DD 00:00:00';
export const DATE_TIME_AT_23_59_59 = 'YYYY-MM-DD 23:59:59';

/**
 * SPECIAL HOURS AND DAYS
 */
export const NIGH_SHIFT_START_TIME = ' 22:00:00';
export const NIGHT_SHIFT_END_TIME = ' 02:01:00';
export const MAURICE_TIME_LIMIT = ' 07:00:00';
export const NIGHT_SHIFT_MIDI = ' 12:00:00';
export const NIGHT_SHIFT_MIDI_ALMOST = ' 11:59:59';
export const NORMAL_SHIFT_START_TIME = ' 08:00:00';
export const NORMAL_SHIFT_END_TIME = ' 18:00:00';
export const NIGHT_SHIFT_MIDNIGHT = ' 00:00:00';
export const NIGHT_SHIFT_MIDNIGHT_ALMOST = ' 23:59:59';
export const MIN_DATE_TO_APPLY_NIGHT_SHIFT = '2019-10-11';

export const TODAY = moment().format(DATE_DEFAULT_FORMAT);
export const JUSTIFICATION_TIME_INSERT = ['AAP', 'ARH', 'AST', 'CTM', 'DEL', 'GRE', 'ADM', 'CSE', 'ELU', 'TRA', 'VME', 'DED', 'ANR', 'ATC', 'ATR', 'PNF', 'PNO', 'MLC', 'MAP', 'MOB', 'VLM', 'HAL', 'CMM', 'NHC', '111', 'SCT', 'ALT', 'FIR', 'MON', 'PNP', 'PNE', 'REF', 'RAN', 'RDI', 'RHA', 'RNE'];



// WEBPACK FOOTER //
// ./src/app/model/commons/DateConstants.ts